import {
  assign, endpoint, options, check, convert,
} from '../helpers';

/**
 * Brings all report details
 *
 * @function
 * @param {Object} properties All parameters to be used in the function
 */

const reports = (properties) => {
  const props = assign(properties);
  const model = {
    Report: props.data.report,
  };

  fetch(endpoint('/report-detail'), options(model))
    .then(response => response.json())
    .then((response) => {
      check(response.Token);
      if (response.Success) {
        props.success(response.Data);
      } else {
        props.error(convert(response.Message));
      }
    })
    .catch(output => window.console.warn(output));
};

export default reports;
